import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-[#FAFAF5]">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#6B7F3E] hover:text-[#5A6B34] mb-6" data-testid="back-home-link">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="font-display text-4xl font-semibold text-[#1A201A] tracking-tight mb-8">Datenschutzerklärung</h1>
        <div className="space-y-5 text-sm text-[#2C3E2D] leading-relaxed">
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir behandeln Ihre
            Daten vertraulich und entsprechend der gesetzlichen Datenschutzbestimmungen sowie
            dieser Datenschutzerklärung.
          </p>
          <div>
            <h2 className="font-display font-medium text-lg text-[#1A201A] mb-1">Erhebung und Verwendung von Daten</h2>
            <p className="text-[#5C6B5D]">
              Wenn Sie unser Kontakt- oder Terminbuchungsformular verwenden, werden die dort
              angegebenen Daten (Name, Adresse, Kontakt, Angaben zum Objekt) zur Bearbeitung
              Ihrer Anfrage verwendet und sicher gespeichert.
            </p>
          </div>
          <div>
            <h2 className="font-display font-medium text-lg text-[#1A201A] mb-1">Ihre Rechte</h2>
            <p className="text-[#5C6B5D]">
              Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung
              der Verarbeitung Ihrer Daten sowie ein Widerspruchsrecht.
            </p>
          </div>
          <div>
            <h2 className="font-display font-medium text-lg text-[#1A201A] mb-1">Verantwortlich</h2>
            <p className="text-[#5C6B5D]">
              Blessing Dienstleistungen, Marvin Blessing, Weiergarten 7a, 79423 Heitersheim
            </p>
          </div>
          <p className="text-xs text-[#5C6B5D] italic">
            Dies ist eine Platzhalterseite. Vor Live-Gang bitte durch eine juristisch geprüfte
            Datenschutzerklärung ersetzen.
          </p>
        </div>
      </div>
    </div>
  );
}
